module.exports = __webpack_public_path__ + "assets/249b5b5ad230352d88a0c77cc9b0f7b8.mp3";